import { useAtom } from "@reatom/npm-react"

import { Checkbox, Dropdown, Label } from "ui-kit/components-branded/index"
import { Method } from "utils/interfaces"
import { methodsAtom } from "modules/PsyCatalog/common/models/filterForm"
import { methodsFetcher } from "modules/PsyCatalog/common/models/methods/methodsFetcher"
import { formatLabel } from "modules/PsyCatalog/common/Filters/formatLabel"

function getMethods(methods: Method[], ids: number[]) {
    return methods.filter((method) => ids.includes(method.id))
}

export function MethodsDropdown() {
    const [value] = useAtom(methodsAtom.inputValue)
    const [methods] = useAtom(methodsFetcher.dataAtom)
    const ready = methods.length > 0

    return (
        <>
            <Label htmlFor="methods" className="label-with-opacity">
                Методы
            </Label>
            <Dropdown
                multiSelect
                label={formatLabel(ready ? "success" : "loading", methods, (data) =>
                    getMethods(data, value)
                        .map((item) => item.name)
                        .join(", ")
                )}
                className="is-fullwidth is-old"
            >
                {methods?.map((method) => (
                    <Dropdown.Item key={method.id}>
                        <Checkbox
                            value={method.id}
                            onChange={() => methodsAtom.onChange(method.id)}
                            checked={value.includes(method.id)}
                        >
                            {method.name}
                        </Checkbox>
                    </Dropdown.Item>
                ))}
            </Dropdown>
        </>
    )
}
